export enum BackgroundSize {
  COVER = 'cover',
  CONTAIN = 'contain',
}

export enum CardVariant {
  DEFAULT = 'default',
  SELECTABLE = 'selectable',
}

export enum Color {
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
}
